// extracted by mini-css-extract-plugin
export var lang = "langSwitch-module--lang--a2N9a";
export var btn = "langSwitch-module--btn--1kFEe";
export var list = "langSwitch-module--list--23-u4";
export var activeLink = "langSwitch-module--activeLink--ksDHD";
export var inner = "langSwitch-module--inner--UknNo";